module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-row', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "justify-center": ""
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline"
  }, [_vm._v("\n          Stats\n        ")]), _vm._v(" "), _c('v-card-text', [_c('p', [_vm._v("Total Orgs: " + _vm._s(_vm.organizations))])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2392c4ba","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
// module id = 414
// module chunks = 1